import React from "react";
import "./style.scss";

const Switch = ({ ...rest }) => {
  return (
    <label className="switch-input">
      <input className="switch-input__input" type="checkbox" {...rest} />
      <span className="switch-input__slider"></span>
    </label>
  );
};

export default Switch;
